import { useQuery } from '@tanstack/react-query';
import { graphqlRequest } from '~/adapters/graphqlRequest';
import { CommentsDocument } from '~/gql/graphql';
import { appQueryClient } from '~/adapters/reactQuery';

export const commentsKeys = {
  allComments: () => ['comments'],
  comments: (input) => [...commentsKeys.allComments(), input],
};

type CommentsQueryInput = {
  companyId: number;
  surveyIds: number[];
  questionId: number;
  surveyElementId: number;
  attributes?: number[];
  searchText: string | null;
  limit: number;
  offset: number;
  keyword: string | null;
  sentimentFilter: string[] | null;
  themeFilter: number[] | null;
  entityFilter: any[] | null;
  managerReportIds?: string[] | null;
  isHierarchyReport?: boolean | null;
  selectedParticipantId?: number;
  sort?: { column: string | null; order: string };
  selectedTimeframe?: { startTimeUTC: string; endTimeUTC: string } | null;
};

export const commentsOptions = (input: CommentsQueryInput) => {
  return {
    queryKey: commentsKeys.comments(input),
    queryFn: async () => {
      const res = await graphqlRequest<any>(CommentsDocument, input);
      return res.data;
    },
  };
};

export const useCommentsQuery = (input: CommentsQueryInput) => {
  return useQuery(commentsOptions(input));
};

export const commentsQuery = (input: CommentsQueryInput) => {
  return appQueryClient.fetchQuery(commentsOptions(input));
};
